import React from 'react'
import PropTypes from 'prop-types'
import { Link } from "react-router-dom";

export default function Navbar(props) {
  return (
    <nav className={`navbar navbar-expand-lg navbar-${props.theme} bg-${props.theme}`}>
      <div className="container-fluid">
        <Link className="navbar-brand" to="/">{props.title}</Link>
        <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarSupportedContent">
          <ul className="navbar-nav me-auto mb-2 mb-lg-0">
            {/* <li className="nav-item">
              <Link className="nav-link active" to="/">Home</Link>
            </li> */}
            {/* <li className="nav-item">
            <Link className="nav-link active" to="/about">{props.reAbout}</Link>
            </li> */}
        {/* <li className="nav-item">
              <a className="nav-a" href="/service">Service</a>
            </li>
            <li className="nav-item">
              <a className="nav-a" href="/contact">Contact</a>
            </li> */}
          </ul>
          <div className={`form-check form-switch fw-bold text-${props.theme === 'light' ? 'dark' : 'light'}`}>
            <input className="form-check-input" type="checkbox" onClick={props.toggleMode} role="switch" id="flexSwitchCheckDefault" />
            <label className="form-check-label" htmlFor="flexSwitchCheckDefault">Enable Dark Mode</label>
          </div>
        </div>

      </div>
    </nav>
  )
}

Navbar.propTypes = {
  title: PropTypes.string.isRequired,
  reAbout: PropTypes.string.isRequired,
}

Navbar.defaultProps = {
  title: 'Set Title Here',
  reAbout: 'About',

}